import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "app/modules/aiAssistant/styles/shared.scss";
import "./AIAssistantPopup.scss";
import { faTimes } from "@fortawesome/pro-solid-svg-icons";
import { selectAssistantOpen, setAssistantOpen } from "app/modules/aiAssistant/AIAssistantSlice";
import { useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import CopySupportDetailsButton from "app/modules/aiAssistant/shared/components/CopySupportDetailsButton";
import ConversationView from "app/modules/aiAssistant/conversation/ConversationView";
import { ASSISTIMO_ICON_SRC } from "app/modules/aiAssistant/shared/constants";

const AIAssistantPopup = () => {
  const inputRef = useRef<HTMLTextAreaElement>(null);
  const dispatch = useDispatch();
  const isAssistantOpen = useSelector(selectAssistantOpen);

  useEffect(() => {
    if (isAssistantOpen) {
      inputRef.current?.focus();
    }
  }, [isAssistantOpen]);

  return (
    <div className={`assistimo-popup ${isAssistantOpen ? "assistimo-popup--open" : ""}`}>
      <div className="assistimo-popup__header">
        <div className="assistimo-brand">
          <img src={ASSISTIMO_ICON_SRC} alt="" />
          <span>Assistimo</span>
          <span className="assistimo-beta-tag">BETA</span>
        </div>
        <div className="assistimo-popup__header-actions">
          <CopySupportDetailsButton data-test-id="assistimo-popup__copy-button" />
          <button
            data-test-id="assistimo-popup__close-button"
            type="button"
            className="assistimo-icon-button"
            aria-label="Close Assistimo"
            onClick={() => dispatch(setAssistantOpen(false))}
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
      </div>
      <ConversationView
        ref={inputRef}
        testIds={{
          getCopyButton: (messageID) => `assistimo-popup__copy-button-${messageID}`,
          getFeedback: (control, messageID) => `assistimo-popup__feedback-${control}-${messageID}`,
          getSuggestedPromptButton: (promptID) => `assistimo-popup__suggested-prompt-button-${promptID}`,
          thinkingToggleButton: "assistimo-popup__thinking-toggle-button",
          messageInput: "assistimo-popup__message-input",
          sendButton: "assistimo-popup__send-message-button",
        }}
      />
    </div>
  );
};

export default AIAssistantPopup;
